<template>
  <section>
    <div class="container" v-if="tourGuides.length > 0">
      <UISectionTitle class="mb-8">
        {{ t("tour_guides") }}
      </UISectionTitle>
      <div class="flex flex-wrap gap-10 justify-center">
        <NuxtLink
          v-for="tourGuide in tourGuides"
          :key="tourGuide.id"
          :to="localPath('/brand-ambassador/' + tourGuide.id.toString())"
          class="cursor-pointer hover:opacity-80 transition-opacity"
        >
          <NuxtImg
            :src="tourGuide.image"
            class="w-24 h-24 rounded-full mx-auto mb-5"
            alt=""
          />
          <p class="text-center">
            {{ tourGuide.name }}
          </p>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n();
const localPath = useLocalePath();
const BaseUrl = inject("BaseUrl") as string;
const tourGuides = ref<Ambassador[]>([]);
const { data } = await useAuthFetch<Api>(`${BaseUrl}/brand-ambassador`);
tourGuides.value = (data.value?.data.tourGuide as Ambassador[]) || [];
</script>
